<template>
    <div class="box">
        <img :src="require('@/assets/img/qietu/shelves.png')" alt="">
        <p>文章已下架</p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.box {
    margin-top: 200px;
    width: 1200px;
    text-align: center;
    img {
        width: 280px;
        height: 235px;
    }
    p {
        margin-top: 10px;
        font-size: 14px;
        color: #333333;
    }
}
</style>